// extracted by mini-css-extract-plugin
export var contrastLow = "_2c-1";
export var externalLink = "_2c-2";
export var externalLinkIcon = "_2c-3";
export var link = "_2c-0";
export var linkLabel = "_2c-4";